const ApiLink = () => {
    if (Environment() === "local") {
        return 'https://localhost:44377/'
    } else if (Environment() === "qa") {
        return "https://qa-a.ynet.co.il/mShort/content/API/glgltz/";
    } else {
        return "https://z.ynet.co.il/mShort/content/API/glgltz/";
    }
}
const Environment = () => {
    if (window.location.href.includes("localhost")) {
        return "local";
    } else if (window.location.href.includes('qa')) {
        return "qa";
    } else {
        return "production";
    }
}

export {ApiLink, Environment};